<template>
  <div>
    <el-dialog
      :visible.sync="show"
      :show-close="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="512px"
      custom-class="coupon-dialog"
    >
      <div class="coupon-dialog-template">
        <div class="dialog-header">
          <div class="title">
            {{ $t('page.couponList.couponPolicy') }}
          </div>
          <div
            class="close-icon-container"
            @click="closeHander"
          >
            <i class="iconfont icon-close" />
          </div>
        </div>
        <div class="dialog-body">
          <div class="content">
            <div
              v-for="(item, index) in pageConfig.policyInfo"
              :key="index"
              class="sentence"
            >
              <b>{{ index + 1 }}. </b>
              <i v-html="item" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      pageConfig: this.$t('page.couponList'),
    }
  },
  methods: {
    closeHander() {
      // 通知父级更新弹出层显示状态
      this.$emit('update:show', false);
    },
  },

}
</script>

<style lang="scss"  >
.el-dialog.coupon-dialog {
  background: none;
  box-shadow: none;
  .el-dialog__header { display: none; }

  .el-dialog__body {
    position: relative;
    padding: 0 !important;
    width: 512px;

    .dialog-body {
      width: 100%;
      height: 420px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 20px 0;

      .content {
        height: 388px;
        overflow-y: scroll;
        padding: 0 20px 20px 20px;

        .sentence {
          margin-bottom: 20px;
          font-size: 16px;
          word-break: break-word;
          line-height: 19px;
          font-weight: 500;
          color: var(--txt-color-lv2);

          b {
            font-size: 16px;
            font-weight: 500;
            color: var(--txt-color-lv2);
          }
          i { font-style: normal; }
        }
      }
    }

    .coupon-dialog-template .dialog-header {
      height: 60px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      margin-bottom: 2px;

      .title {
        font-size: 20px;
        font-weight: 500;
        color: rgba(69, 85, 113, 1);
        line-height: 60px;
      }

      .close-icon-container {
        position: absolute;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 32px;
        height: 32px;
        top: 15px;
        right: 15px;
        border-radius: 50%;
        background: #f4f6fa;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
</style>
